import * as React from "react";

interface IProps {
    accidentHourTime: string;
    disabled?: boolean;
    onChange: (event: any) => void;
}

export class HourTimeSelectComponent extends React.Component<IProps> {

    public render() {
        return (
            <>
                <div className="inline-radio" key={0}>
                    <input
                        className="custom-control-input"
                        type="radio"
                        name="amTimeRadio"
                        id="amTimeRadio"
                        value="AM"
                        checked={this.props.accidentHourTime === "AM"}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled}
                    />
                    <label className="custom-control-label" htmlFor="amTimeRadio">AM</label>
                </div>
                <div className="radio-divider">/</div>
                <div className="inline-radio" key={1}>
                    <input
                        className="custom-control-input"
                        type="radio"
                        name="pmTimeRadio"
                        id="pmTimeRadio"
                        value="PM"
                        checked={this.props.accidentHourTime === "PM"}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled}
                    />
                    <label className="custom-control-label" htmlFor="pmTimeRadio">PM</label>
                </div>
            </>
        )
    }
}
